import { createContext } from 'react'

interface SpoilerContextType {
  state: 'fold' | 'expand'
  isExpanded: boolean
  toggle: () => void
}

export const SpoilerContext = createContext<SpoilerContextType | undefined>(
  undefined,
)
